export enum BackLinkVariantEnum {
  Default = 'blue',
  White = 'white',
}
